//Main eStories App Run

angular.module('eStories', [
    'ui.router',
    'angular-carousel',
    'ngTouch',
    'ngAnimate',
    'eStories.navbars',
    'eStories.autocomplete',
    'eStories.search',
    'eStories.plans',
    'eStories.home',
    'eStories.seeAll',
    'eStories.library',
    'eStories.terms',
    'eStories.promoTerms',
    'eStories.privacy',
    'eStories.audiobook',
    'eStories.registration',
    'eStories.author',
    'eStories.mobileFilter',
    'eStories.mobileSort',
    'eStories.narrator',
    'eStories.browse',
    'eStories.genre',
    'eStories.gift',
    'eStories.upload',
    'eStories.publisher',
    'eStories.notifications',
    'eStories.modals',
    'eStories.paging',
    'eStories.pagination',
    'eStories.wishList',
    'eStories.account',
    'eStories.communicationSettings',
    'eStories.howItWorks',
    'eStories.mobileApps',
    'eStories.freemium',
    'eStories.specialTrial',
    'eStories.promo',
    'eStories.theme',
    'eStories.freeaudiobook',
    'eStories.promoEligibility',
    'eStories.resetPw',
    'eStories.server.notifications.model',
    'eStories.google.model',
    'eStories.registration.model',
    'eStories.gift.model',
    'eStories.cta.model',
    'eStories.headers.tribook',
    'eStories.library.top.bar',
    'eStories.affiliatesProgram.model',
    'global.webServices.factory',
    'global.filters',
    'global.directives',
    'localytics.factory',
    'googleAnalytics.factory',
    'rzModule',
    'eStories.seo.model',
    'ngCookies',
    'ngAria',
    'avatar.compnt',
    /*Player Providers*/
    'filePerChapterPlayerProvider.model',
    'findawayPlayerProvider.model',
    'multiChapterFilePlayerProvider.model'

    //import modules
])

    .config(['$stateProvider', '$urlRouterProvider', '$locationProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider) {
            $stateProvider
                .state('eStories', {
                    url: '',
                    'abstract': true
                });

            $locationProvider.html5Mode({enabled: true, requireBase: false});

            $urlRouterProvider.otherwise(async function ($injector, $location) {
                const splitPath = $location.path().split("/");
                if (splitPath.length >= 2) {
                    const vanityPart = splitPath[1].trim().toLowerCase();
                    const WS = $injector.get('WS');
                    const response = await WS.callServer('catalog/getVanityUrl', {name: vanityPart});
                    if (response.responseStatus === 'SUCCESS') {
                        window.location.href = response.vanityUrl.redirectUrl;
                    } else {
                        $location.path('/');
                    }
                }
            });
        }])

    .run(['AccountModel',
        '$rootScope',
        '$window',
        'ModalsModel',
        '$timeout',
        'BillingModel',
        '$state',
        '$location',
        'PromoModel',
        'PagingModel',
        'PlayerModel',
        'ServerNotificationsModel',
        'CtaModel',
        'UploadModel',
        'AffiliatesProgramModel',
        'LL',
        'GiftModel',
        'SeoModel',
        'CatalogModel',
        '$uibModalStack',
        function (AccountModel,
                  $rootScope,
                  $window,
                  ModalsModel,
                  $timeout,
                  BillingModel,
                  $state,
                  $location,
                  PromoModel,
                  PagingModel,
                  PlayerModel,
                  ServerNotificationsModel,
                  CtaModel,
                  UploadModel,
                  AffiliatesProgramModel,
                  LL,
                  GiftModel,
                  SeoModel,
                  CatalogModel,
                  $uibModalStack) {

            $rootScope.$watch(() => document.querySelectorAll('.modal').length, val => {
                for (let modal of document.querySelectorAll('.modal')) {
                    let top = $uibModalStack.getTop();
                    if (top && top.value.backdrop !== 'static') {
                        modal.addEventListener('mousedown', e => {
                            if (e.which === 1 && top) {
                                top.key.dismiss()
                            }
                        });
                        modal.querySelector('.modal-content').addEventListener('mousedown', e => {
                            e.stopPropagation()
                        })
                    }
                }
                if (val > 0) {
                    $uibModalStack.getTop().value.backdrop = 'static'
                }
            });

            /*Initial Localytics Top Event*/
            LL.tagEvent('Started Session');

            ServerNotificationsModel.initServerNotificationsModel();
            $rootScope.billingModel = BillingModel;
            $rootScope.accountModel = AccountModel;
            $rootScope.uploadModel = UploadModel;
            $rootScope.pagingModel = PagingModel;
            $rootScope.playerModel = PlayerModel;
            $rootScope.affiliatesProgramModel = AffiliatesProgramModel;
            $rootScope.promoModel = PromoModel;
            $rootScope.giftModel = GiftModel;
            $rootScope.ctaModel = CtaModel;
            $rootScope.catalogModel = CatalogModel;
            $rootScope.seoModel = SeoModel;
            $rootScope.ll = LL;
            $rootScope.urlContentValue = window.location.origin;
            $rootScope.grantAccessToApp = localStorage.getItem('PRIVATE_ACCESS') != null;
            $rootScope.unlockHighlightMode = {
                "sequence": isProduction() ? "qwertyhgfdsa" : "qwe",
                "lastCharacter" : null,
                "enabled": false
            };

            $rootScope.detectBrowser = function () {
                if (isSafari) {
                    return "safari";
                } else if (isFirefox) {
                    return "firefox";
                } else {
                    return "";
                }
            };

            $rootScope.isHighlightMode = function () {
                if ($rootScope.unlockHighlightMode.enabled) {
                    return "HIGHLIGHT_MODE";
                } else {
                    return "";
                }
            };

            $rootScope.detectKeys = function (e) {
                const nextCharIndex =
                    1 + $rootScope.unlockHighlightMode.sequence.indexOf($rootScope.unlockHighlightMode.lastCharacter);

                if (e.key == $rootScope.unlockHighlightMode.sequence[nextCharIndex]) {
                    $rootScope.unlockHighlightMode.lastCharacter = e.key;
                    if (nextCharIndex == $rootScope.unlockHighlightMode.sequence.length-1) {
                        $rootScope.unlockHighlightMode.enabled = true;
                    }
                } else {
                    $rootScope.unlockHighlightMode.lastCharacter = null;
                }
            };

            $rootScope.isMobileDevice = function () {
                return isMobile;
            };

            PromoModel.searchPromoParams();

            let shouldRunPromo = function () {
                return $window.location.href.indexOf('2cdt') === -1 &&
                    $window.location.href.indexOf('freeaudiobook') === -1 &&
                    $location.search()['offerType'] !== 'freeTrial' &&
                    $window.location.href.indexOf('startnow') === -1
            };

            AffiliatesProgramModel.storeUtmPackageCookie(31);

            CtaModel.searchCtaParam();

            $rootScope.homeCtrlLoaded = false;
            $rootScope.navbarsCtrlLoaded = false;

            $rootScope.$on('homeCtrlLoaded', function (event) {
                $rootScope.homeCtrlLoaded = true;
            });

            $rootScope.$on('navbarsCtrlLoaded', function (event) {
                $rootScope.navbarsCtrlLoaded = true;
            });

            let broadcastSuccessfulSignIn = function () {
                if ($rootScope.navbarsCtrlLoaded) {
                    $rootScope.$broadcast('successfulSignIn');
                } else {
                    $timeout(broadcastSuccessfulSignIn, 50);
                }
            };

            let broadcastHomePageSections = function () {
                if ($rootScope.homeCtrlLoaded) {
                    $rootScope.$broadcast('refreshHomePageSections');
                } else {
                    $timeout(broadcastHomePageSections, 50);
                }
            };

            AccountModel.refreshUserDetails(function () {
                broadcastSuccessfulSignIn();
            }, function () {
                AccountModel.reportSubscriptionDetailsLoaded();
                broadcastHomePageSections();
            });

            BillingModel.getAllPlans();

            $rootScope.windowWidth = $window.innerWidth;
            $rootScope.windowHeight = $window.innerHeight;

            this.windowResizedTimeout = null;
            var currentWindow = angular.element($window);
            currentWindow.bind('resize', () => {
                $rootScope.windowWidth = $window.innerWidth;
                $rootScope.windowHeight = $window.innerHeight;
                $rootScope.$broadcast("windowResized");
                if (this.windowResizedTimeout) {
                    clearTimeout(this.windowResizedTimeout);
                    this.windowResizedTimeout = null;
                }
                this.windowResizedTimeout = setTimeout(() => {
                    safeApply($rootScope);
                }, 10)
            });

            $rootScope.stateOnlyForLoggedInUser = function (currentState) {
                switch (currentState) {
                    case 'eStories.navbars.wishList':
                    case 'eStories.navbars.library':
                    case 'eStories.navbars.account.overview':
                    case 'eStories.navbars.account':
                    case 'eStories.navbars.account.cancel':
                    case 'eStories.navbars.account.upload':
                    case 'eStories.navbars.account.booster':
                    case 'eStories.navbars.communicationSettings':
                        return true;
                        break;
                    default:
                        return false;
                }
            };

            $rootScope.stateForPromoPlans = function (currentState) {
                return currentState === 'eStories.navbars.50Off3Mo';
            };

            $rootScope.$on('$viewContentLoaded', function (event) {
                $rootScope.currentState = $state.current.name;
                $rootScope.$broadcast('hideSearchbar');

                //When logged in and trying to access one of the 'locked' pages a.e. 'library', 'wishlist', this returns so that it doesnt redirect to '/'
                if (!AccountModel.subscriptionDetailsLoaded) {
                    // Not done loading page
                    return;
                }

                $('html,body').scrollTop(0);

            });

            let stateOnHomeCtrl = function () {
                return $location.$$path === '/' ||
                    $location.$$path === '/homepage' ||
                    $location.$$path === '/startTrial' ||
                    $location.$$path === '/vipSignUp' ||
                    $location.$$path === '/newUser' ||
                    $location.$$path === '/signUp' ||
                    $location.$$path === '/signIn' ||
                    $location.$$path === '/dailydeal'
            };

            /*checkForSession*/
            CatalogModel.loadHomePageSectionsAsync = stateOnHomeCtrl();

            /*Preload How It Works Assets*/
            function preloadHowItWorksAssets() {
                var howItWorksAssets = [
                    '/xl.svg',
                    '/bg-phones.svg',
                    '/bg-first-band.svg',
                    '/sect-3-phones-and-app.svg',
                    '/bg-third-band-m.svg',
                    '/sect-4-bg.svg',
                    '/bookstackblackheadphones.svg'
                ];
                for (var i = 0; i < howItWorksAssets.length; i++) {
                    var image = new Image();
                    image.src = 'assets/img/home/howItWorks' + howItWorksAssets[i];
                }
            }

            preloadHowItWorksAssets();
        }
    ]);
